import { jwtDecode } from 'jwt-decode';
import { canContinuePreparedOffline } from '../offline/offlineSession';

let logoutTimer = null;

export function scheduleTokenExpiration(token, onExpire = () => {
  if (canContinuePreparedOffline()) return;
  localStorage.removeItem('velaToken');
  window.location.href = '/login';
}) {
  try {
    const { exp } = jwtDecode(token);
    const timeLeft = exp * 1000 - Date.now();

    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }

    logoutTimer = setTimeout(() => {
      // Another tab may have replaced this JWT for the same signed-in user.
      // Never let a timer belonging to the old token clear the newer session.
      if (localStorage.getItem('velaToken') !== token) return;

      if (canContinuePreparedOffline()) {
        window.dispatchEvent(new CustomEvent('vela:session-expired'));
        return;
      }
      onExpire();
    }, Math.max(0, timeLeft));
  } catch (err) {
    console.warn('Unable to decode JWT for expiration:', err);
    onExpire();
  }
}

export function clearScheduledLogout() {
  if (logoutTimer) {
    clearTimeout(logoutTimer);
    logoutTimer = null;
  }
}
